import { Single as WarehouseSingle } from './Single';

export default WarehouseSingle;
